import { useEffect, useState } from 'react';

// Counts down to a target ISO-8601 timestamp and returns the remaining seconds.
// Returns 0 when the deadline has passed or when `expiresAt` is null.
// Ticks once per second; stops on unmount or when the deadline changes.
export function useCountdown(expiresAt: string | null): number {
  const [secondsLeft, setSecondsLeft] = useState(() => computeSecondsLeft(expiresAt));

  useEffect(() => {
    setSecondsLeft(computeSecondsLeft(expiresAt));
    if (!expiresAt) return;
    const interval = setInterval(() => {
      const next = computeSecondsLeft(expiresAt);
      setSecondsLeft(next);
      if (next <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [expiresAt]);

  return secondsLeft;
}

function computeSecondsLeft(expiresAt: string | null): number {
  if (!expiresAt) return 0;
  const diffMs = new Date(expiresAt).getTime() - Date.now();
  if (Number.isNaN(diffMs) || diffMs <= 0) return 0;
  return Math.ceil(diffMs / 1000);
}
